import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  footer: {
    position: 'absolute',
    bottom: '45px',
    width: '70%',
    height: '40px',
    '@media(max-width: 1015px)': {
      bottom: '90px'
    }
  },
  cardHeader: {
    background: '#ffffff',
    border: 'none',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '15px',
    width: '70%',
  },
  confirmation: {
    textAlign: 'center',
  },
  header: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '28px',
    color: '#2c2d3e',
    minWidth: '350px',
    textAlign: 'center',
    marginBottom: '30px',
    paddingRight: '5px',
  },
  logo: {
    height: '44px',
    paddingLeft: '3px',
    paddingRight: '3px',
  },
  logosContainer: {
    float: 'right',
    marginRight: '3%',
  },
  sidePanel: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    width: '30%',
    height: '100%',
    backgroundImage: 'linear-gradient(#3c419a, #27284c)',
  },
  sideHeader: {
    display: 'flex',
    position: 'relative',
    top: '47%',
    justifyContent: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'bold',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '28px',
    color: '#ffffff',
    textWrap: 'none',
  },
  sideSubheader: {
    display: 'flex',
    position: 'relative',
    top: '49%',
    justifyContent: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '19px',
    lineHeight: '28px',
    color: '#ffffff',
    cursor: 'default',
  },
  separator: {
    width: '96%',
    marginLeft: '1px',
    marginTop: '1rem',
    marginBottom: '1rem',
    border: 0,
    borderTop: '1px solid rgba(0,0,0,.1)',
  },
}));
